import Vue from 'vue'
import axios from 'axios'
import { auth } from 'utils'

axios.defaults.baseURL = process.env.VUE_APP_API_URL + 'api/v2'
axios.defaults.withCredentials = true
axios.defaults.headers['Accept'] = 'application/json'

let showingUnauthorizedError = false

axios.interceptors.response.use((response) => {
  return response
}, async (error) => {
  if (error.response && error.response.status === 401) {
    await auth.redirectOnSessionExpired()

    return Promise.reject(error)
  }

  // For 403s we'll throw a blanket error notification and redirect them back to the dashboard.
  if (error.response && error.response.status === 403) {
    if (!showingUnauthorizedError) {
      Vue.noty.error('You do not have permission to do that.').on('afterClose', () => {
        showingUnauthorizedError = false
      })

      showingUnauthorizedError = true
    }

    auth.redirectOnForbidden()

    return Promise.reject(new Error('Forbidden'))
  }

  if (error.response && error.response.status === 500) {
    Vue.noty.error(error.response.data.message)
  }

  return Promise.reject(error)
})

// Set Axios on our Vue instances so we can have easier access to it via "this.$http" should we
// need to make requests within our components.
Vue.prototype.$http = axios

export default axios

/**
 * Handle server validation errors by adding them to an error bag.
 *
 * @return void
 */
export const handleServerErrors = (exception, observer) => {
  if (exception.response && exception.response.status === 422) {
    const { errors } = exception.response.data

    for (const ref in observer.refs) {
      const provider = observer.refs[ref]
      if (errors[provider.name]) {
        provider.setErrors(errors[provider.name])
      } else if (errors[provider.vid]) {
        provider.setErrors(errors[provider.vid])
      } else {
        provider.reset()
      }
    }

    return true
  } else {
    return false
  }
}

/**
 * Generate URL to API.
 *
 * @return string
 */
export const apiUrl = (path) => {
  if (path === undefined) {
    return process.env.VUE_APP_API_URL
  }

  return `${process.env.VUE_APP_API_URL}${path}`
}
